import { fetch } from '@/commen/http.js'
import { getUrlParam  } from '@/commen/util';

const orgid = getUrlParam('_orgid_');
// 获取上报记录
export const scoreInfo = ({params}) => {
  return fetch({
    url: `/api/total?_orgid_=${orgid}`,
    params
  })
}